import axios from 'axios';
import { apiInstance } from "./config";

const login = async (endpoint: any, payload: any) => {
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_BASE_URL}${endpoint}`,
            payload
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

const logout = async (endpoint: any) => {
    try {
        const response = await apiInstance.post(endpoint);
        return response.data;
    } catch (error) {
        throw error;
    }
}

const persistUser = async (endpoint: any) => {
    try {
        const response = await apiInstance.get(endpoint);
        return response.data;
    } catch (error) {
        throw error;
    }
};

interface ForgotPasswordResponse {
    success: boolean;
    status: number;
    message: string;
}

const forgotPassword = async (endpoint: string, email: string) => {
    try {
        const response = await apiInstance.post<ForgotPasswordResponse>(endpoint, { email });
        if (!response.data.success) {
            throw new Error(response.data.message);
        }
        return response.data;
    } catch (error) {
        console.error('Error in forgot password:', error);
        throw error;
    }
};

interface ResetPasswordResponse {
    success: boolean;
    status: number;
    message: string;
}

const resetPassword = async (endpoint: string, payload: { 
    token: string; 
    email: string;
    password: string 
}) => {
    try {
        const response = await axios.post<ResetPasswordResponse>(`${process.env.REACT_APP_BASE_URL}${endpoint}`, payload);
        if (!response.data.success) {
            throw new Error(response.data.message);
        }
        return response.data;
    } catch (error) {
        console.error('Error in reset password:', error);
        throw error;
    }
};

export const AUTH_SERVICE = {
    login,
    logout,
    persistUser,
    forgotPassword,
    resetPassword,
};
